import React from 'react';
import styled from 'styled-components';
import {
  HeadlineOne,
  Paragraph,
  UnderHeader,
} from 'components/atoms/SectionWrapper.style';
import { cms } from 'assets/cms';

const OptimalizationImg = styled.div`
  background: center center url(${cms.images.moneybox});
  background-size: cover;
  height: 250px;
  background-repeat: no-repeat;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${({ theme }) => theme.media.tablet} {
    height: 400px;
  }
  padding: 35px;
`;
const OptimalizationImages = () => (
  <>
    <UnderHeader />
    <OptimalizationImg>
      <Paragraph>Receco</Paragraph>
      <HeadlineOne>Optymalizacja kosztów energii</HeadlineOne>
    </OptimalizationImg>
  </>
);

export default OptimalizationImages;
